// extracted by mini-css-extract-plugin
export default {"container":"bussinesConsulting_container__+sQcV"};